import { receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { camelizeKeys } from 'receivable-invoices-js/react/utils/camelize-keys';
import { fetchQuotes } from './fetch-quotes';

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  receivableInvoicesApiNamespace: '/api/v5',
}));

vi.mock('@repo/design-system-kit', () => ({
  useToast: vi.fn(() => ({
    showToast: vi.fn(),
  })),
}));

describe('unit | API | queries | fetch-quotes', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const clientId = 'client-123';
  const URL = `${receivableInvoicesApiNamespace}/receivable_invoices/quotes/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  // Use function reference instead of string
  describe(fetchQuotes, () => {
    it('fetches quotes successfully', async () => {
      const apiResponse = {
        data: [
          {
            id: 'quote-123',
            type: 'quote',
            attributes: {
              locale: 'fr',
              number: 'D-2025-004',
              status: 'pending_approval',
              terms_and_conditions: '',
              subtotal: {
                value: '100.00',
                currency: 'EUR',
              },
              vat_amount: {
                value: '20.00',
                currency: 'EUR',
              },
              amount_due: {
                value: '120.00',
                currency: 'EUR',
              },
              issue_date: '2025-08-28',
              expiry_date: '2025-11-26',
              pdf_url: 'https://pdf.url',
              currency: 'EUR',
              contact_email: 'jane@doe.com',
              stamp_duty_amount: {
                value: '0.00',
                currency: 'EUR',
              },
              sections: [
                {
                  id: '0198f19d-19e8-785d-926f-fbf33090b120',
                  items: [
                    {
                      title: 'Web services',
                      description: '',
                      quantity: '1',
                      unit_price: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      unit: 'hour',
                      vat_rate: '0.2',
                      total_vat: {
                        value: '20.00',
                        currency: 'EUR',
                      },
                      total_amount: {
                        value: '120.00',
                        currency: 'EUR',
                      },
                      subtotal: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                    },
                  ],
                },
              ],
              organization: {
                id: '123456789',
                slug: 'slug',
                legal_name: 'Some Organization',
                legal_form: 'SAS',
                legal_number: '123456789',
                legal_country: 'FR',
                vat_number: '',
                district_court: '',
                company_leadership: '',
                commercial_register_number: '',
                legal_capital_share: null,
                vat_payment_condition: '',
                transaction_type: '',
                tax_number: '',
                address_line1: '18 Rue de Navarin',
                address_line2: '',
                address_zipcode: '75009',
                address_city: 'Paris',
                address_country: 'FR',
              },
              customer_snapshot: {
                kind: 'company',
                name: 'Company name',
                first_name: '',
                last_name: '',
                tin_number: '123456789',
                vat_number: '123456789',
                address_line1: '18 Rue de Nav',
                address_line2: '',
                address_zipcode: '75009',
                address_city: 'Paris',
                address_country: 'FR',
              },
              is_close_to_expire: false,
              remaining_days_until_expiry: 88,
              is_pdf_generated: true,
              quote_versions: [
                {
                  id: '123456789',
                  created_at: '2025-08-28T16:57:41Z',
                  pdf_url: 'https://pdf.url',
                },
              ],
              created_at: '2025-08-28T16:57:41Z',
            },
          },
        ],
      };

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchQuotes({ clientId }, {});

      expect(mockQontoClient).toHaveBeenCalledWith(URL, {
        params: { client_id: clientId, page: { number: 1, size: 100 } },
      });

      expect(result).toStrictEqual(
        camelizeKeys([
          {
            locale: 'fr',
            number: 'D-2025-004',
            status: 'pending_approval',
            terms_and_conditions: '',
            subtotal: {
              value: '100.00',
              currency: 'EUR',
            },
            vat_amount: {
              value: '20.00',
              currency: 'EUR',
            },
            amount_due: {
              value: '120.00',
              currency: 'EUR',
            },
            issue_date: '2025-08-28',
            expiry_date: '2025-11-26',
            pdf_url: 'https://pdf.url',
            currency: 'EUR',
            contact_email: 'jane@doe.com',
            stamp_duty_amount: {
              value: '0.00',
              currency: 'EUR',
            },
            sections: [
              {
                id: '0198f19d-19e8-785d-926f-fbf33090b120',
                items: [
                  {
                    title: 'Web services',
                    description: '',
                    quantity: '1',
                    unit_price: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    unit: 'hour',
                    vat_rate: '0.2',
                    total_vat: {
                      value: '20.00',
                      currency: 'EUR',
                    },
                    total_amount: {
                      value: '120.00',
                      currency: 'EUR',
                    },
                    subtotal: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                  },
                ],
              },
            ],
            organization: {
              id: '123456789',
              slug: 'slug',
              legal_name: 'Some Organization',
              legal_form: 'SAS',
              legal_number: '123456789',
              legal_country: 'FR',
              vat_number: '',
              district_court: '',
              company_leadership: '',
              commercial_register_number: '',
              legal_capital_share: null,
              vat_payment_condition: '',
              transaction_type: '',
              tax_number: '',
              address_line1: '18 Rue de Navarin',
              address_line2: '',
              address_zipcode: '75009',
              address_city: 'Paris',
              address_country: 'FR',
            },
            customer_snapshot: {
              kind: 'company',
              name: 'Company name',
              first_name: '',
              last_name: '',
              tin_number: '123456789',
              vat_number: '123456789',
              address_line1: '18 Rue de Nav',
              address_line2: '',
              address_zipcode: '75009',
              address_city: 'Paris',
              address_country: 'FR',
            },
            is_close_to_expire: false,
            remaining_days_until_expiry: 88,
            is_pdf_generated: true,
            quote_versions: [
              {
                id: '123456789',
                created_at: '2025-08-28T16:57:41Z',
                pdf_url: 'https://pdf.url',
              },
            ],
            created_at: '2025-08-28T16:57:41Z',
            id: 'quote-123',
          },
        ])
      );
    });

    it('handles API errors with custom error handler', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      const onError = vi.fn<(err: unknown) => void>();
      await fetchQuotes({ clientId }, { onError });

      expect(onError).toHaveBeenCalledWith(error);
    });

    it('throws error when no error handler is provided', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      await expect(fetchQuotes({ clientId }, {})).rejects.toThrow('API Error');
    });

    it('handles empty response data', async () => {
      const mockResponse = {
        data: [],
      };
      mockQontoClient.mockResolvedValue(mockResponse);

      const result = await fetchQuotes({ clientId }, {});

      expect(result).toStrictEqual([]);
    });
  });
});
